import { SearchPlaceholder } from "designSystem/index";
import React from "react";

export default () => (
	<SearchPlaceholder
		titleProps={{ res: "Search title" }}
	/>
);
